<div class="page-breadcrumb">
    <div class="row">
        <div class="col-7 align-self-center">

            <h4 class="page-title">Reports Management</h4>
        </div>

    </div>
</div>

<!-- <div  style="margin-top: 37px;" *ngIf="write!=true && read!=true && delete!=true ">
   
    <div class="box">
        <div class="text-center">
          
            <p class="text-muted my-4" style="color:#353556!important;font-size: x-large;font-weight: 600;font-family: initial;">YOU DON'T HAVE ANY PERMISSION TO ACCESS ON THIS PAGE.</p>
            
        </div>
    </div>
</div> -->



<div>


    <div style="margin-top:-22px;">

        <div class="container-fluid">
            <!-- ============================================================== -->
            <!-- Start Page Content -->
            <!-- ============================================================== -->
            <div class="row">
                <!-- Column -->
                <div class="col-lg-12">
                    <div class="card">
                        <div class="card-body">
                            <form #banner="ngForm" novalidate>
                                <div class="form-body">
                                    <h5 class="card-title"> Reports Management</h5>
                                    <hr>
                                    <div class="row">
                                        <div class="col-md-6">
                                            <div class="form-group">
                                                <label class="control-label"> Report Name</label>
                                                <select class="form-control" id="notificationType" required
                                                    #notificationType="ngModel" name="notificationType"
                                                    [(ngModel)]="reportsAddObj.reportName"
                                                    data-placeholder="Choose a reportName Type" tabindex="1">
                                                    <option value="DemandForecast">Demand Forecast </option>
                                                    <option value="HistoricalConsumption">Historical Consumption
                                                    </option>
                                                    <option value="HistoricalWastage">Historical Wastage
                                                    </option>
                                                    <option value="MarketShare">Market Share
                                                    </option>
                                                </select>


                                            </div>
                                        </div>

                                        <div class="col-md-6">
                                            <div class="form-group">
                                                <label class="control-label">Pin code</label>
                                                <input type="text" id="pinCode" class="form-control"
                                                    onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                                                    required maxlength="30" #pinCode="ngModel" name="pinCode"
                                                    [(ngModel)]="reportsAddObj.pincode" placeholder="pinCode"
                                                    maxlength="40">
                                                <span style="font-size: small" class="text-danger"
                                                    [hidden]="!pinCode.errors.required"
                                                    *ngIf="pinCode.errors && (pinCode.touched || pinCode.dirty)">
                                                    *This Field is Required</span>
                                                <br>

                                            </div>
                                        </div>

                                    </div>
                                    <div class="row">
                                        <div class="col-md-6">
                                            <div class="form-group">
                                                <label class="control-label">Category Name</label>
                                                <select class="form-control" #categoryId="ngModel"
                                                    (change)="getSubCategoryByCategoryId(reportsAddObj.category)"
                                                    name="categoryId" [(ngModel)]="reportsAddObj.category"
                                                    data-placeholder="Choose a Role Name" tabindex="1">
                                                    <option disabled="" value="" selected>Category</option>

                                                    <option *ngFor="let cl of categoriesList" value="{{cl.name}}">
                                                        {{cl.name}}</option>
                                                </select>
                                                <span class="text-danger" [hidden]="!categoryId.errors.required"
                                                    *ngIf="categoryId.errors && (categoryId.touched || categoryId.dirty)">*Please
                                                    select Category
                                                </span>
                                                <br>

                                            </div>
                                        </div>
                                        <div class="col-md-6">
                                            <div class="form-group">
                                                <label class="control-label">Sub Category Name</label>
                                                <select class="form-control" #subCategoryId="ngModel"
                                                    name="subCategoryId" [(ngModel)]="reportsAddObj.subCategory"
                                                    data-placeholder="Choose a Sub Category" tabindex="1">
                                                    <option disabled="" value="" selected>Sub Category</option>

                                                    <option *ngFor="let scl of subCategoriesList" value="{{scl.name}}">
                                                        {{scl.name}}</option>

                                                </select>
                                                <span class="text-danger" [hidden]="!subCategoryId.errors.required"
                                                    *ngIf="subCategoryId.errors && (subCategoryId.touched || subCategoryId.dirty)">*Please
                                                    select Sub Category
                                                </span>
                                                <br>

                                            </div>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-md-6">
                                            <div class="form-group">
                                                <input type="radio" id="fromto" name="fromto"
                                                    [(ngModel)]="reportTypeSelectedValue" value="fd"
                                                    (change)="applyCustomizedFilter()" style="margin-top: 29px;"><span>From
                                                        Date - To Date &nbsp;&nbsp;</span>
                                                <input type="radio" id="period" name="period"
                                                    [(ngModel)]="reportTypeSelectedValue" value="pvp"
                                                    (change)="applyCustomizedFilter()">Period to Period Comparision
                                                &nbsp;&nbsp;

                                                <br>

                                            </div>
                                        </div>

                                    </div>
                                    <div *ngIf="showRegular">

                                        <div class="row">
                                            <div class="col-md-6">
                                                <div class="form-group">
                                                    <input type="date" id="emailId" name="gender"
                                                        [(ngModel)]="reportsAddObj.fromDate" value="fd"
                                                        (change)="applyCustomizedFilter()"
                                                        style="margin-top: 29px;">From
                                                    Date &nbsp;&nbsp;
                                                    <input type="date" id="name" name="gender"
                                                        [(ngModel)]="reportsAddObj.toDate" value="pvp"
                                                        (change)="applyCustomizedFilter()">To Date&nbsp;&nbsp;
                                                </div>
                                            </div>


                                        </div>
                                        <div class="row">
                                            <div class="col-md-6">
                                                    <input type="checkbox" (change)="toggleVisibility($event)">
                                                    &nbsp;
                                                    <label class="check"> Periodic Date</label>

                                            </div>
                                        </div>
                                        <div class="row" *ngIf="show">
                                            <div class="col-md-6">
                                                <div class="form-group">
                                                    <select class="form-control" id="notificationType" required
                                                        #notificationType="ngModel" name="notificationType"
                                                        [(ngModel)]="reportsAddObj.periodicType"
                                                        data-placeholder="Choose a reportName Type" tabindex="1">
                                                        <option value="Weekly">Weekly
                                                        </option>
                                                        <option value="Monthly">Monthly

                                                        </option>

                                                    </select>


                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div *ngIf="showPeriodVsPeriod">

                                        <div >
                                            <ngx-slider [(value)]="value" [options]="options"
                                                style="font-size: 13px;background-color: #353556;;width: 40%;">
                                            </ngx-slider>
                                        </div>
                                        <div class="row">
                                            <div class="col-md-6">
                                                <div class="form-group">
                                                    <select class="form-control" id="notificationType" required
                                                        #notificationType="ngModel" name="notificationType"
                                                        [(ngModel)]="reportsAddObj.periodicType"
                                                        (change)="handleSlider(reportsAddObj.periodicType)"
                                                        data-placeholder="Choose a reportName Type" tabindex="1">
                                                        <option value="Weekly">Weekly</option>
                                                        <option value="Monthly">Monthly</option>
                                                        <option value="Quarterly">Quarterly</option>
                                                        <option value="Annually">Annualy</option>

                                                    </select>


                                                </div>
                                            </div>
                                        </div>
                                        <div  *ngIf="showPeriodSlider">
                                            <ngx-slider [(value)]="periodValue" [(highValue)]="periodHighValue"
                                                [options]="periodOption"
                                                style="font-size: 13px;background-color: #353556;;width: 40%;">
                                            </ngx-slider>

                                        </div>
                                    </div>

                                </div>

                                <div class="form-actions m-t-40">
                                    <button type="submit" style="background-color: #353556;color:white"
                                        data-dismiss="modal" class="btn" (click)="getReports()"> Submit</button>
                                    &nbsp;&nbsp;

                                </div>

                            </form>
                            <!-- <div class="d-flex justify-content-center" *ngIf="showSpinner">
                                <div class="spinner-border" role="status">
                                    <span class="sr-only" id="loading"></span>
                                </div>
                            </div> -->
                            <div class="col-12 d-flex align-items-center justify-content-center mt-4 mb-2" *ngIf="showSpinner">
                                <div class="snippet" data-title=".dot-flashing">
                                  <div class="stage">
                                    <div class="dot-flashing"></div>
                                  </div>
                                </div>
                              </div>
                        </div>
                    </div>
                </div>
                <!-- Column -->
            </div>

        </div>

    </div>
</div>
<div>


    <div style="margin-top:-22px;">

        <div class="container-fluid">
            <!-- ============================================================== -->
            <!-- Start Page Content -->
            <!-- ============================================================== -->
            <div class="row">
                <!-- Column -->
                <div class="col-lg-12">
                    <div class="card">
                        <div class="card-body">
                            <div *ngIf="showDates">
                                <div class="row">
                                    <div class="col-md-6">
                                        <div class="form-group">
                                            <label class="control-label"> Total Value</label>
                                            <div>{{sumResult.TotalAmount}}</div>
                            
                                        </div>
                                    </div>
                            
                                    <div class="col-md-6">
                                        <div class="form-group">
                                            <label class="control-label">Total Quantity</label>
                                            <div>{{sumResult.TotalQuantity}}</div>
                            
                                            <br>
                            
                                        </div>
                                    </div>
                            
                                </div>
                                <div class="row">
                                    <div class="col-lg-12">
                                        <div class="card">
                                            <div class="card-body">
                                                <div class="table-responsive">
                                                    <div id="zero_config_wrapper"
                                                        class="dataTables_wrapper container-fluid dt-bootstrap4 no-footer">
                            
                                                        <div>
                                                            <div>
                            
                                                                <mat-form-field>
                                                                    <input class="search" placeholder="Search" matInput>
                            
                                                                </mat-form-field>
                            
                                                            </div>
                                                            <div class="table-responsive">
                                                                <table class="table" id="Example table" mat-table [dataSource]="dataSource" matSort
                                                                    style=" margin-top: 30px;">
                            
                                                                    <ng-container matColumnDef="accountEmailId">
                                                                        <th mat-header-cell *matHeaderCellDef mat-sort-header>Account Email Id</th>
                                                                        <td *matCellDef="let row">
                                                                            {{row.accountEmailId}}
                                                                        </td>
                                                                    </ng-container>
                            
                                                                    <ng-container matColumnDef="productName">
                                                                        <th mat-header-cell *matHeaderCellDef mat-sort-header>Product Name</th>
                                                                        <td *matCellDef="let row">
                                                                            {{row.productName}}
                                                                        </td>
                                                                    </ng-container>
                                                                    <ng-container matColumnDef="productImage">
                                                                        <th mat-header-cell *matHeaderCellDef mat-sort-header>Product Image</th>
                                                                        <td *matCellDef="let row" style="white-space: nowrap;">
                                                                            <button class="dropdown-item" data-toggle="modal"
                                                                                (click)="viewImages(row._id)" data-target="#responsiveImages"
                                                                                style="color:rgb(30, 110, 124)">
                                                                                View
                                                                            </button>
                                                                        </td>
                                                                    </ng-container>
                                                                    <ng-container matColumnDef="productUniqueNumber">
                                                                        <th mat-header-cell *matHeaderCellDef mat-sort-header> Product Unique Number
                                                                        </th>
                                                                        <td *matCellDef="let row">
                                                                            {{row.productUniqueNumber}}
                                                                        </td>
                                                                    </ng-container>
                                                                    <ng-container matColumnDef="description">
                                                                        <th mat-header-cell *matHeaderCellDef mat-sort-header> Description</th>
                                                                        <td *matCellDef="let row">
                                                                            {{row.description}}
                                                                        </td>
                                                                    </ng-container>
                                                                    <ng-container matColumnDef="stockQuantity">
                                                                        <th mat-header-cell *matHeaderCellDef mat-sort-header>Stock Quantity</th>
                                                                        <td *matCellDef="let row">
                                                                            {{row.stockQuantity}}
                                                                        </td>
                                                                    </ng-container>
                                                                    <ng-container matColumnDef="stockUnit">
                                                                        <th mat-header-cell *matHeaderCellDef mat-sort-header> Stock Unit</th>
                                                                        <td *matCellDef="let row">
                                                                            {{row.stockUnit}}
                                                                        </td>
                                                                    </ng-container>
                                                                    <ng-container matColumnDef="purchaseDate">
                                                                        <th mat-header-cell *matHeaderCellDef mat-sort-header>Purchase Date</th>
                                                                        <td *matCellDef="let row">
                                                                            {{row.purchaseDate|date}}
                                                                        </td>
                                                                    </ng-container>
                                                                    <ng-container matColumnDef="expiryDate">
                                                                        <th mat-header-cell *matHeaderCellDef mat-sort-header> Expiry Date</th>
                                                                        <td *matCellDef="let row">
                                                                            {{row.expiryDate|date}}
                                                                        </td>
                                                                    </ng-container>
                                                                    <ng-container matColumnDef="storageLocation">
                                                                        <th mat-header-cell *matHeaderCellDef mat-sort-header>Storage Location</th>
                                                                        <td *matCellDef="let row">
                                                                            {{row.storageLocation}}
                                                                        </td>
                                                                    </ng-container>
                                                                    <ng-container matColumnDef="borrowed">
                                                                        <th mat-header-cell *matHeaderCellDef mat-sort-header> Borrowed/Lent/Shared
                                                                        </th>
                                                                        <td *matCellDef="let row">
                                                                            {{row.borrowed}}
                                                                        </td>
                                                                    </ng-container>
                                                                    <ng-container matColumnDef="category">
                                                                        <th mat-header-cell *matHeaderCellDef mat-sort-header
                                                                            style="padding-left: 40px;">Category</th>
                                                                        <td *matCellDef="let row" style="padding-left: 40px;">
                                                                            {{row.category}}
                                                                        </td>
                                                                    </ng-container>
                                                                    <ng-container matColumnDef="subCategory">
                                                                        <th mat-header-cell *matHeaderCellDef mat-sort-header> Sub Category</th>
                                                                        <td *matCellDef="let row">
                                                                            {{row.subCategory}}
                                                                        </td>
                                                                    </ng-container>
                                                                    <ng-container matColumnDef="price">
                                                                        <th mat-header-cell *matHeaderCellDef mat-sort-header>Price</th>
                                                                        <td *matCellDef="let row">
                                                                            {{row.price}}
                                                                        </td>
                                                                    </ng-container>
                                                                    <ng-container matColumnDef="orderId">
                                                                        <th mat-header-cell *matHeaderCellDef mat-sort-header>Order Id</th>
                                                                        <td *matCellDef="let row">
                                                                            {{row.orderId}}
                                                                        </td>
                                                                    </ng-container>
                                                                    <ng-container matColumnDef="vendor">
                                                                        <th mat-header-cell *matHeaderCellDef mat-sort-header> Vendor Name</th>
                                                                        <td *matCellDef="let row">
                                                                            {{row.vendor}}
                                                                        </td>
                                                                    </ng-container>
                                                                    <ng-container matColumnDef="uploadType">
                                                                        <th mat-header-cell *matHeaderCellDef mat-sort-header>Upload Type</th>
                                                                        <td *matCellDef="let row">
                                                                            {{row.UploadType}}
                                                                        </td>
                                                                    </ng-container>
                                                                    <ng-container matColumnDef="status">
                                                                        <th mat-header-cell *matHeaderCellDef mat-sort-header>Status</th>
                                                                        <td *matCellDef="let row">
                                                                            <span *ngIf="row.status==true"> Active</span>
                                                                            <span *ngIf="row.status==false"> In Active</span>
                                                                        </td>
                                                                    </ng-container>
                                                                    <ng-container matColumnDef="productManuallyAddOrAutoMovedDate">
                                                                        <th mat-header-cell *matHeaderCellDef mat-sort-header> Product Manually
                                                                            Added Or AutoMoved Date</th>
                                                                        <td *matCellDef="let row">
                                                                            {{row.productManuallyAddOrAutoMovedDate|date}}
                                                                        </td>
                                                                    </ng-container>
                                                                    <ng-container matColumnDef="addedByUserId">
                                                                        <th mat-header-cell *matHeaderCellDef mat-sort-header>Added By User Id</th>
                                                                        <td *matCellDef="let row">
                                                                            {{row.addedByUserId}}
                                                                        </td>
                                                                    </ng-container>
                            
                            
                            
                            
                                                                    <tr mat-header-row *matHeaderRowDef='displayedColumns'>
                                                                    </tr>
                                                                    <tr mat-row *matRowDef="let row;columns:displayedColumns"></tr>
                                                                </table>
                                                            </div>
                            
                                                        </div>
                            
                                                    </div>
                                                </div>
                                                <mat-paginator [length]="100" [pageSize]="10" [pageSizeOptions]="[5, 10, 25,100]"
                                                    showFirstLastButtons>
                                                </mat-paginator>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div *ngIf="showPeriod">
                                <div class="row">
                                    <div class="col-md-6">
                                        <div class="form-group">
                                            <label class="control-label"> Total Value</label>
                                            <div>{{sumResult.TotalAmount}}</div>
                            
                                        </div>
                                    </div>
                            
                                    <div class="col-md-6">
                                        <div class="form-group">
                                            <label class="control-label">Total Quantity</label>
                                            <div>{{sumResult.TotalQuantity}}</div>
                            
                                            <br>
                            
                                        </div>
                                    </div>
                            
                                </div>
                                <div class="row">
                                    <div class="col-lg-12">
                                        <div class="card">
                                            <div class="card-body">
                                                <div class="table-responsive">
                                                    <div id="zero_config_wrapper"
                                                        class="dataTables_wrapper container-fluid dt-bootstrap4 no-footer">
                            
                                                        <div>
                                                            <div>
                            
                                                                <mat-form-field>
                                                                    <input class="search" placeholder="Search" matInput>
                            
                                                                </mat-form-field>
                            
                                                            </div>
                                                            <div class="table-responsive">
                                                                <table class="table" id="Example table" mat-table [dataSource]="dataSourceWeek"
                                                                    matSort style=" margin-top: 30px;">
                            
                                                                    <ng-container matColumnDef="period">
                                                                        <th mat-header-cell *matHeaderCellDef mat-sort-header>Period</th>
                                                                        <td *matCellDef="let row">
                                                                            {{row.number}}
                                                                        </td>
                                                                    </ng-container>
                            
                                                                    <ng-container matColumnDef="totalvalution">
                                                                        <th mat-header-cell *matHeaderCellDef mat-sort-header>Total Valution</th>
                                                                        <td *matCellDef="let row">
                                                                            {{row.TotalAmount}}
                                                                        </td>
                                                                    </ng-container>
                            
                                                                    <ng-container matColumnDef="prodcount">
                                                                        <th mat-header-cell *matHeaderCellDef mat-sort-header> Product Count
                                                                        </th>
                                                                        <td *matCellDef="let row">
                                                                            {{row.TotalQuantity}}
                                                                        </td>
                                                                    </ng-container>
                            
                            
                            
                            
                            
                            
                            
                                                                    <tr mat-header-row *matHeaderRowDef='displayedWeekColumns'>
                                                                    </tr>
                                                                    <tr mat-row *matRowDef="let row;columns:displayedWeekColumns"></tr>
                                                                </table>
                                                            </div>
                            
                                                        </div>
                            
                                                    </div>
                                                </div>
                            
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="card" *ngIf="showPeriodVsPeriodResult">
                            
                                <div [innerHTML]="da"> </div>
                            
                            </div>
                        </div>
                    </div>
                </div>
                <!-- Column -->
            </div>

        </div>

    </div>
</div>


<div id="responsiveImages" class="modal fade" tabindex="-1" data-width="760" style="display: none;">
    <div class="modal-dialog" id="box" style="margin-left: 300px">
        <div class="modal-content" style="width:900px">
            <div class="modal-header">
                <button type="button" class="close btn-danger" data-dismiss="modal">X
                </button>
            </div>
            <div class="modal-body">
                <img style="text-indent: -10000px" src="{{myurl+'Misc/Images/productImages/'+productImageId+'_0'}}"
                    width="100" height="100" />
                <img style="text-indent: -10000px" src="{{myurl+'Misc/Images/productImages/'+productImageId+'_1'}}"
                    width="100" height="100" />
                <img style="text-indent: -10000px" src="{{myurl+'Misc/Images/productImages/'+productImageId+'_2'}}"
                    width="100" height="100" />
            </div>
        </div>
    </div>
</div>

<!-- Container fluid  -->
<!-- ============================================================== -->
